import React from 'react';
import { useHistory } from 'react-router-dom';
import { EmptyState, Flex } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import ForbiddenSVG from '../../assets/forbidden.svg?raw';
import { ROUTES } from '../../constants/app';
import PrimaryButton from '../shared/PrimaryButton';
import { svgtob64 } from '../../helpers/utils';
import FullScreenContainer from '../shared/styled-components/FullScreenContainer';

const Forbidden: React.FC<{ documentType: 'guide' | 'page' }> = ({
  documentType,
}) => {
  const { translate } = useTranslate();
  const history = useHistory();

  return (
    <FullScreenContainer>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <img
          src={svgtob64(ForbiddenSVG)}
          alt={translate('FORBIDDEN.IMG_ALT')}
        />
        <EmptyState
          title={
            documentType === 'page' ? (
              <Translate id="FORBIDDEN.HEADER_TEXT_PAGE" />
            ) : (
              <Translate id="FORBIDDEN.HEADER_TEXT" />
            )
          }
          text={
            documentType === 'page' ? (
              <Translate id="FORBIDDEN.PARAGRAPH_TEXT_PAGE" />
            ) : (
              <Translate id="FORBIDDEN.PARAGRAPH_TEXT" />
            )
          }
          actions={
            <PrimaryButton onClick={() => history.push(ROUTES.GUIDE_OVERVIEW)}>
              <Translate id="FORBIDDEN.BUTTON_TEXT" />
            </PrimaryButton>
          }
        />
      </Flex>
    </FullScreenContainer>
  );
};

export default Forbidden;
